import { z } from "zod";
import { LeadFormSchema } from "./schema";

export type LeadFormDataType = z.infer<typeof LeadFormSchema>;

export enum ActionsTypeEnum {
  WHATSAPP = "whatsapp",
  MESSAGE = "message",
}
